import {omit} from 'lodash';
import React from 'react';

import {type Ref} from '../../../state/views/filter/types';
import {usePart} from '../../../state/views/hooks';
import {WBTableActionFilterButton} from '../WBTable/WBTableActionsFilter';

interface RunsFilterButtonProps {
  compact?: boolean;
  notificationOpen: boolean;
  filtersOpen: boolean;
  filtersRef: Ref;
}

export const RunsFilterButton = (props: RunsFilterButtonProps) => {
  const filters = usePart(props.filtersRef);
  const passThroughProps = omit(props, 'compact', 'filtersOpen', 'filtersRef');

  return (
    <WBTableActionFilterButton
      {...passThroughProps} // Required for use as popup trigger
      compact={props.compact}
      filtersOpen={props.filtersOpen}
      filters={filters}
    />
  );
};
